// extracted by mini-css-extract-plugin
export default {"default":"List_default__0LfsG","list":"List_list__-+KAG","list_item":"List_list_item__v+DzG","selected":"List_selected__7MOj5","dark":"List_dark__AGAu4"};